import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import notifications from './modules/notifications'
import security from './modules/security'
import account from './modules/account'
import fulfillment from './modules/fulfillment'
import product from './modules/product'
import settlement from './modules/settlement'
import settlementreport from './modules/settlementreport'
import setmodalitiescommand from './modules/setmodalitiescommand'
import mediaobject from './modules/mediaobject'
import setproductimagecommand from './modules/setproductimagecommand'
import setskulistcommand from './modules/setskulistcommand'
import accountsettlementcontinuation from './modules/accountsettlementcontinuation'
import setsettlementreportconfigcommand from './modules/setsettlementreportconfigcommand'

Vue.use(Vuex)

/* eslint-disable no-new */
const store = new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    notifications,
    security,
    account,
    fulfillment,
    product,
    settlement,
    settlementreport,
    setmodalitiescommand,
    mediaobject,
    setproductimagecommand,
    setskulistcommand,
    accountsettlementcontinuation,
    setsettlementreportconfigcommand
  }
})

export default store
